module.exports = __webpack_public_path__ + "static/media/McNuggets.0bf22b22.png";